<template>
<loading :show="show" :label="label" :overlay="overlay"></loading>
    <form class="form-horizontal">
        <div class="form-body">
            <div class="form-group">
                <div class="col-md-7 input-palavra">
                    <label class="control-label">Palavra Chave</label>
                    <input type="text" class="form-control" placeholder="Insira Palavra chave">
                </div>

                <div class="col-md-2 input-ano new-padding-inputs">
                    <label class="control-label">Ano</label>
                    <select class="form-control">
                    </select>
                </div>

                <div class="col-md-2 input-mes new-padding-inputs">
                    <label class="control-label">Mes</label>
                    <select class="form-control">

                    </select>
                </div>

                <div class="col-md-2 botao-pesquisar">
                    <label class="control-label"></label>
                    <button class="form-control btn green" style="margin-top: 8px;" v-on:click="pesquisar">Pesquisar</button>
                </div>
            </div>
        </div>
    </form>
    <hr >
    <div>
        <div class="portlet-body">
            <cp-table v-if="line == 'table1'" :dadosconteudo="dadosconteudo"></cp-table>
            <cp-table-cinco v-if="line == 'table5'" :dadosconteudo="dadosconteudo"></cp-table-cinco>
        </div>
    </div>
</template>
<script>
    import CpTable from '../../tables/table-t1/table.vue'
            import CpTableCinco from '../../tables/table-t5/table.vue'
            import loading from 'vue-full-loading'

            export default{
                data() {
                    return{
                        dadosconteudo: {},
                        show: false,
                        label: 'Carregando...',
                        overlay: true                        
                    }
                },
                ready: function(){
                    MPL.handleFiltro();   
                    $('form').bind('submit',function(e){e.preventDefault();});
                    //MPL.loadButton();
                    this.pesquisar();
                },
                watch: {
                    $route () {
                        this.pesquisar();
                    }
                },
                components: {
                    CpTable, CpTableCinco, loading
                },
                props: {
                    line: {}
                },
                methods: {
                    pesquisar(ev) {
                        
                        
                        $.ajaxSetup({
                            async: false
                        });
                        this.show = true;
                        var self = this;
                        if (this.$route.params.tipo == 'legislacao') {
                            setTimeout(function(){
                                MPL.loadDadosLegislacao(1, function (dados) {                                
                                    self.dadosconteudo = dados[0];
                                    self.show = false;
                                    $('.table-responsive').fadeIn('fast');                                             
                                });
                            }, 200);
                        }

                        //json com os dados do menu
                        // if (this.$route.params.tipo == 'diarias') {
                        //     $.getJSON('./src/components/tables/table-t5/datatable2.json', function (links)
                        //     {
                        //         self.dadosconteudo = links[0];
                        //         //console.log(self.dadosconteudo)
                        //     });
                        // }

                        $.ajaxSetup({
                            async: true
                        });
                        
                        // $('.table-responsive').fadeIn('fast');  
                    }
                }
            }
</script>

<style scoped>
    .input-palavra{
        width: 58.5%;
    }
</style>


// WEBPACK FOOTER //
// filtro.vue?431f579d